export default "<div [@color]=\"state\">\n  <ng-content></ng-content>\n</div>\n"